angular.module('qkr.department')
    .controller('departmentManagementController', ($scope, $uibModal, departmentService, appConfig, departments,
                                                   $routeSegment, paymentConfigList) => {
        const SUPPLIER_MERCHANT_CATEGORY = 'Supplier';
        const vm = $scope;
        vm.modalOpen = false;
        vm.departmentList = departments;
        vm.paymentConfigList = paymentConfigList;
        vm.isSupplier = (appConfig.businessCategory === SUPPLIER_MERCHANT_CATEGORY);
        vm.isDepartmentManager = appConfig.isDepartmentManager;

        const updateDepartmentOrder = function(evt, ui) {
            updateDepartmentOrderImpl(ui.item.sortable.index, ui.item.sortable.dropindex);
        };

        const updateDepartmentOrderImpl = function(oldIndex, newIndex) {
            if((oldIndex < 0 || oldIndex >= $scope.departmentList.length)||
                (newIndex < 0 || newIndex >= $scope.departmentList.length)){
                return;
            }

            const departmentsPendingCount = vm.departmentList
                .filter(d => d.shareStatus === 'Pending')
                .length;

            newIndex = newIndex - departmentsPendingCount;

            const itemBeingMoved = $scope.departmentList[oldIndex];

            const department = Object.assign({}, itemBeingMoved, {departmentOrder: newIndex > 0 ? newIndex : 0});

            departmentService.moveDepartment(department.id, department.departmentOrder)
                .then(() => vm.onDepartmentListChanged());
        };

        const fixHelper = function(e, ui) {
            ui.children().each((index, elem) => {
                $(elem).width($(elem).width());
            });
            return ui;
        };

        const startHelper = function(event, ui) {
            return ui.placeholder.children().each((index, child) => {
                const source = ui.helper.children().eq(index);
                $(child).removeAttr('class').addClass(source.attr('class'));
            });
        };

        vm.sortableOptions = {
            helper: fixHelper,
            cancel: '.unsortable',
            update: updateDepartmentOrder,
            start: startHelper,
            axis: 'y'
        };

        vm.createDepartment = function() {
            showEditDepartment(false);
        };

        vm.editDepartment = function(department) {
            if (!department.readOnly) {
                const editDepartment = angular.copy(department);
                showEditDepartment(true, editDepartment);
            }
        };

        vm.onDepartmentListChanged = function() {
            $routeSegment.chain[0].reload();
        };

        vm.$on('paymentSettingsChanged', (evt, response) => {
            vm.paymentConfigList = response.data;
        });

        vm.getAliasOfPaymentConfig = function(paymentConfigRef) {
            if (paymentConfigRef) {
                const id = paymentConfigRef.id;
                angular.forEach(vm.paymentConfigList, (paymentConfig) => {
                    if (id === paymentConfig.id) {
                        return paymentConfig.alias;
                    }
                });

                return '';
            } else {
                angular.forEach(vm.paymentConfigList, (paymentConfig) => {
                    if (paymentConfig.fallback) {
                        return paymentConfig.alias + ' (Default)';
                    }
                });
                return 'Undefined';
            }
        };

        vm.onDepartmentDragHandleKeyDown = function(event, department){
            const keyCodes = {
                ESC: 27,
                UP: 38,
                DOWN: 40,
            };

            if([keyCodes.UP, keyCodes.DOWN].includes(event.keyCode)){
                event.preventDefault();

                const currentIndex = department ?
                    vm.departmentList.findIndex((d) => d.id === department.id) :
                    -1;

                //This call will reject the negatives so we don't need to check again
                updateDepartmentOrderImpl(currentIndex,
                    event.keyCode === keyCodes.UP ?
                        currentIndex-1 : currentIndex+1
                );
            }else if(event.keyCode === keyCodes.ESC && event.target){
                //remove the focus on escape
                event.target.blur();
            }
        };

        function showEditDepartment(isEdit, department) {
            vm.isModalOpen = true;
            const modalInstance = $uibModal.open({
                template: require('../../department/templates/department.html'),
                controller: 'DepartmentManagmentModalDialogController',
                windowClass: 'modal-huge',
                backdrop: 'static',
                resolve: {
                    isEdit() {
                        return isEdit;
                    },
                    department() {
                        return department;
                    },
                    paymentConfigList() {
                        return vm.paymentConfigList;
                    }
                }
            });

            modalInstance.result.then(result => {
                vm.isModalOpen = false;
                if (result === 'done') {
                    vm.onDepartmentListChanged();
                }
                return null;
            }).catch(e => {});
        }

    });



// WEBPACK FOOTER //
// ./src/department/controllers/department.management.controller.js